import React from 'react';

export function AboutKyron() {
  return (
    <div>
      <h1>About Kyron Coming Soon!</h1>
    </div>
  );
}
